/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrebidImportStatusDto } from '../../models/prebid-import-status-dto';

export interface GetPrebidImportStatus$Params {
  'X-API-Version'?: string;
}

export function getPrebidImportStatus(http: HttpClient, rootUrl: string, params?: GetPrebidImportStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportStatusDto>> {
  const rb = new RequestBuilder(rootUrl, getPrebidImportStatus.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidImportStatusDto>;
    })
  );
}

getPrebidImportStatus.PATH = '/api/prebid-import/status';
